import { Checkbox } from '@mui/material';
import { DataCellProps } from '../types';

export const DataDeletionCheckboxCell = ({
  team: { id, teamId },
  _customRowProps: { selectedIds, onToggleRow },
  hideSelectBox,
}: DataCellProps) => {
  if (hideSelectBox) return <></>;
  return (
    <div>
      <Checkbox
        checked={selectedIds.has(id)}
        onClick={() => onToggleRow(id)}
        slotProps={{
          input: { 'aria-label': `select ${teamId}` },
        }}
      />
    </div>
  );
};
